import React from 'react';
import ReactDOM from 'react-dom';
import { MetamaskStateProvider } from 'context/metamaskStore';
import { FavStorageContextProvider } from 'context/favStorageContext';
import { MyNFTsProvider } from 'context/myNFTsContext';
import App from './app/App';
import reportWebVitals from './reportWebVitals';

import './scss/index.scss';

ReactDOM.render(
  <React.StrictMode>
    <MyNFTsProvider>
      <MetamaskStateProvider>
        <FavStorageContextProvider>
          <App />
        </FavStorageContextProvider>
      </MetamaskStateProvider>
    </MyNFTsProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
